import { Color } from '@tmh-website/shared/colors';
import StyledTypo from '@tmh-website/styles/typo';
import styled from 'styled-components';

export const Container = styled.a<{ ref?: any; $isSelected?: boolean }>`
  ${StyledTypo.h5Css};
  display: flex;
  gap: 5px;
  align-items: center;
  padding: 10px;
  margin: 0 -10px;
  color: ${props => props.theme.color[Color.Neutral_0_White]};
  opacity: ${props => (props.$isSelected ? 1 : 0.6)};
  transition: opacity ${props => props.theme.transitionTiming};
  @media (${props => props.theme.breakpoint.md.down}) {
    font-size: 16px;
  }

  &:hover {
    text-decoration: none;
    opacity: 1;
  }
`;
